import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CategoryFilterBar"
}
const _hoisted_2 = { class: "CategoryFilterBarItem-value" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "CategoryFilterBarItem-value" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.changedSlides.length || _ctx.selectedChecks.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changedSlides, (slide) => {
          return (_openBlock(), _createElementBlock("div", {
            key: slide.nameMin + '|' +  slide.nameMax,
            class: "CategoryFilterBarItem"
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(slide.minValue.toLocaleString() + " - " + slide.maxValue.toLocaleString() + " " + slide.unit), 1),
            _createElementVNode("button", {
              class: "CategoryFilterBarItem-remove",
              onClick: ($event: any) => (_ctx.clearFilter({ type: slide.nameMin }))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                width: "10",
                height: "10"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
                })
              ], -1)
            ]), 8, _hoisted_3)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChecks, (check) => {
          return (_openBlock(), _createElementBlock("div", {
            key: check.name + '=' +  check.value,
            class: "CategoryFilterBarItem"
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(check.label), 1),
            _createElementVNode("button", {
              class: "CategoryFilterBarItem-remove",
              onClick: ($event: any) => (_ctx.clearFilter({ name: check.name, value: check.value }))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                width: "10",
                height: "10"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
                })
              ], -1)
            ]), 8, _hoisted_5)
          ]))
        }), 128)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter(null))),
          class: "CategoryFilterBar-reset",
          type: "button"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 320 512"
          }, [
            _createElementVNode("path", {
              fill: "currentColor",
              d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
            })
          ], -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.cancelLabel), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}